<script>
    import Polygon from "./Polygon.svelte";
    import {createEventDispatcher} from "svelte";
    import Point from "./Point.svelte";
    import Line from "./Line.svelte";
    import {LINE_STRING, POINT, POLYGON} from "../Styles";

    export let styles;
    export let hasPolygons = true;
    export let hasPoints = true;
    export let hasLines = true;

    $: polygon = styles[POLYGON];
    $: point = styles[POINT];
    $: line = styles[LINE_STRING];

    const dispatch = createEventDispatcher();

    const changeStyle = geometryType => e => {
        const newStyles = {
            ...styles
        }

        newStyles[geometryType] = e.detail;

        dispatch('changeStyle', newStyles);
    }
</script>

{#if hasPolygons}
    <section>
        <h4>Polygon style</h4>

        <Polygon style={polygon} on:changeStyle={changeStyle(POLYGON)}/>
    </section>
{/if}

{#if hasPoints}
    <section>
        <h4>Point style</h4>

        <Point style={point} on:changeStyle={changeStyle(POINT)} />
    </section>
{/if}

{#if hasLines}
    <section>
        <h4>Line style</h4>

        <Line style={line} on:changeStyle={changeStyle(LINE_STRING)} />
    </section>
{/if}

<style>
    section {
        padding-bottom: 1em;

    }

    section:not(:last-of-type) {
        border-bottom: 1px solid grey;
    }

    section :global(h5) {
        margin-bottom: 0.5em;
    }
</style>
